
const $disclaimer = $('.js-disclaimer');
const $disclaimerCountry = $('.js-disclaimer-country');
const $disclaimerCountryBtn = $('.js-disclaimer-country-btn');
const $disclaimerCountryScreen = $('.js-disclaimer-screen');

if ($disclaimer.length) {
    App.H.addClass('_noscroll');
    $disclaimer.show();
}

$disclaimerCountry.on('change', function () {
    $disclaimerCountryBtn.removeClass('_disabled-btn');
});

$disclaimerCountryBtn.on('click', function () {
    const currScreen = $disclaimerCountry.find(':selected').data('screen');

    console.log(`.${currScreen}`);

    $disclaimerCountryScreen.removeClass('_showen')
        .filter(`.${currScreen}`).addClass('_showen');
});

$('.js-disclaimer-yes').on('click', function () {
    App.H.removeClass('_noscroll');
    $disclaimer.fadeOut();
});

$('.js-disclaimer-no').on('click', function () {
    $disclaimerCountryScreen.removeClass('_showen')
        .filter(`.screen-2`).addClass('_showen');
});


// WEBPACK FOOTER //
// ./_src/js/Disclaimer.js